import on from './on';

export default on('click');
